export const GUEST_CATEGORIES = [
  { id: 'cat-food', name: 'Food & Dining', color: '#f97316', icon: '🍔' },
  { id: 'cat-groceries', name: 'Groceries', color: '#f59e0b', icon: '🛒' },
  { id: 'cat-shopping', name: 'Shopping', color: '#ec4899', icon: '🛍️' },
  { id: 'cat-transport', name: 'Transport', color: '#3b82f6', icon: '🚗' },
  { id: 'cat-entertainment', name: 'Entertainment', color: '#8b5cf6', icon: '🎬' },
  { id: 'cat-utilities', name: 'Utilities', color: '#06b6d4', icon: '💡' },
  { id: 'cat-travel', name: 'Travel', color: '#14b8a6', icon: '✈️' },
  { id: 'cat-health', name: 'Health', color: '#ef4444', icon: '💊' },
  { id: 'cat-income', name: 'Income', color: '#10b981', icon: '💰' },
  { id: 'cat-uncategorized', name: 'Uncategorized', color: '#6b7280', icon: '📦' },
];

export const SAMPLE_TRANSACTIONS = [
  {
    id: 'sample-tx-01',
    date: '2026-03-24',
    time: '08:30 pm',
    merchant: 'Swiggy',
    rawMerchant: 'Swiggy Food',
    normalized: 'swiggy',
    amount: 485.00,
    type: 'debit',
    category: 'Food & Dining',
    upiRef: '640455321001',
    transactionId: 'T2603242030119284729101',
    status: 'Success'
  },
  {
    id: 'sample-tx-02',
    date: '2026-03-23',
    time: '11:15 am',
    merchant: 'Reliance Fresh',
    rawMerchant: 'Reliance Fresh Store',
    normalized: 'reliancefresh',
    amount: 1420.50,
    type: 'debit',
    category: 'Groceries',
    upiRef: '640455321002',
    transactionId: 'T2603231115203948572839',
    status: 'Success'
  },
  {
    id: 'sample-tx-03',
    date: '2026-03-22',
    time: '04:45 pm',
    merchant: 'Uber India',
    rawMerchant: 'Uber Rides',
    normalized: 'uberindia',
    amount: 340.00,
    type: 'debit',
    category: 'Transport',
    upiRef: '640455321003',
    transactionId: 'T2603221645091827364528',
    status: 'Success'
  },
  {
    id: 'sample-tx-04',
    date: '2026-03-20',
    time: '07:10 pm',
    merchant: 'Amazon Retail',
    rawMerchant: 'Amazon Pay India',
    normalized: 'amazonretail',
    amount: 2199.00,
    type: 'debit',
    category: 'Shopping',
    upiRef: '640455321004',
    transactionId: 'T2603201910438271928475',
    status: 'Success'
  },
  {
    id: 'sample-tx-05',
    date: '2026-03-18',
    time: '01:20 pm',
    merchant: 'Zomato',
    rawMerchant: 'Zomato Order',
    normalized: 'zomato',
    amount: 320.00,
    type: 'debit',
    category: 'Food & Dining',
    upiRef: '640455321005',
    transactionId: 'T2603181320119283746582',
    status: 'Success'
  },
  {
    id: 'sample-tx-06',
    date: '2026-03-16',
    time: '10:00 am',
    merchant: 'Airtel Broadband',
    rawMerchant: 'Airtel Payments Bank',
    normalized: 'airtelbroadband',
    amount: 943.00,
    type: 'debit',
    category: 'Utilities',
    upiRef: '640455321006',
    transactionId: 'T2603161000283746592819',
    status: 'Success'
  },
  {
    id: 'sample-tx-07',
    date: '2026-03-15',
    time: '09:00 am',
    merchant: 'Consulting Project Payout',
    rawMerchant: 'Received from TechCorp Client',
    normalized: 'consultingprojectpayout',
    amount: 35000.00,
    type: 'credit',
    category: 'Income',
    upiRef: '640455321007',
    transactionId: 'T2603150900128374651928',
    status: 'Success'
  },
  {
    id: 'sample-tx-08',
    date: '2026-03-14',
    time: '06:30 pm',
    merchant: 'BookMyShow',
    rawMerchant: 'Bigtree Entertainment',
    normalized: 'bookmyshow',
    amount: 760.00,
    type: 'debit',
    category: 'Entertainment',
    upiRef: '640455321008',
    transactionId: 'T2603141830491827364510',
    status: 'Success'
  },
  {
    id: 'sample-tx-09',
    date: '2026-03-12',
    time: '03:15 pm',
    merchant: 'Apollo Pharmacy',
    rawMerchant: 'Apollo Hospitals Pharm',
    normalized: 'apollopharmacy',
    amount: 540.00,
    type: 'debit',
    category: 'Health',
    upiRef: '640455321009',
    transactionId: 'T2603121515283746192847',
    status: 'Success'
  },
  {
    id: 'sample-tx-10',
    date: '2026-03-10',
    time: '12:40 pm',
    merchant: 'Blue Tokai Coffee',
    rawMerchant: 'Blue Tokai Cafe',
    normalized: 'bluetokaicoffee',
    amount: 290.00,
    type: 'debit',
    category: 'Food & Dining',
    upiRef: '640455321010',
    transactionId: 'T2603101240192837465192',
    status: 'Success'
  },
  {
    id: 'sample-tx-11',
    date: '2026-03-08',
    time: '08:15 pm',
    merchant: 'Blinkit',
    rawMerchant: 'Blink Commerce',
    normalized: 'blinkit',
    amount: 675.00,
    type: 'debit',
    category: 'Groceries',
    upiRef: '640455321011',
    transactionId: 'T2603082015293847561928',
    status: 'Success'
  },
  {
    id: 'sample-tx-12',
    date: '2026-03-05',
    time: '05:00 pm',
    merchant: 'Tata Power Electricity',
    rawMerchant: 'Tata Power Mumbai',
    normalized: 'tatapowerelectricity',
    amount: 1850.00,
    type: 'debit',
    category: 'Utilities',
    upiRef: '640455321012',
    transactionId: 'T2603051700293847561029',
    status: 'Success'
  },
  {
    id: 'sample-tx-13',
    date: '2026-03-02',
    time: '02:30 pm',
    merchant: 'MakeMyTrip Flights',
    rawMerchant: 'MakeMyTrip India',
    normalized: 'makemytripflights',
    amount: 4620.00,
    type: 'debit',
    category: 'Travel',
    upiRef: '640455321013',
    transactionId: 'T2603021430192837465019',
    status: 'Success'
  },
  {
    id: 'sample-tx-14',
    date: '2026-03-01',
    time: '10:00 am',
    merchant: 'Monthly Retainer Salary',
    rawMerchant: 'Credited by Acme Corp',
    normalized: 'monthlyretainersalary',
    amount: 45000.00,
    type: 'credit',
    category: 'Income',
    upiRef: '640455321014',
    transactionId: 'T2603011000192837465928',
    status: 'Success'
  },
  {
    id: 'sample-tx-15',
    date: '2026-02-27',
    time: '09:10 pm',
    merchant: 'Swiggy Instamart',
    rawMerchant: 'Swiggy Instamart',
    normalized: 'swiggyinstamart',
    amount: 512.00,
    type: 'debit',
    category: 'Groceries',
    upiRef: '640455321015',
    transactionId: 'T2602272110293847561028',
    status: 'Success'
  },
  {
    id: 'sample-tx-16',
    date: '2026-02-24',
    time: '07:45 pm',
    merchant: 'Zara Fashion',
    rawMerchant: 'Zara Inditex Store',
    normalized: 'zarafashion',
    amount: 3490.00,
    type: 'debit',
    category: 'Shopping',
    upiRef: '640455321016',
    transactionId: 'T2602241945192837465928',
    status: 'Success'
  },
  {
    id: 'sample-tx-17',
    date: '2026-02-20',
    time: '01:10 pm',
    merchant: 'McDonalds',
    rawMerchant: 'Hardcastle Restaurants',
    normalized: 'mcdonalds',
    amount: 425.00,
    type: 'debit',
    category: 'Food & Dining',
    upiRef: '640455321017',
    transactionId: 'T2602201310293847561928',
    status: 'Success'
  },
  {
    id: 'sample-tx-18',
    date: '2026-02-17',
    time: '11:00 am',
    merchant: 'Netflix Subscription',
    rawMerchant: 'Netflix Entertainment Services',
    normalized: 'netflixsubscription',
    amount: 649.00,
    type: 'debit',
    category: 'Entertainment',
    upiRef: '640455321018',
    transactionId: 'T2602171100293847561029',
    status: 'Success'
  },
  {
    id: 'sample-tx-19',
    date: '2026-02-14',
    time: '08:30 pm',
    merchant: 'Mainland China Dinner',
    rawMerchant: 'Speciality Restaurants',
    normalized: 'mainlandchinadinner',
    amount: 2180.00,
    type: 'debit',
    category: 'Food & Dining',
    upiRef: '640455321019',
    transactionId: 'T2602142030192837465928',
    status: 'Success'
  },
  {
    id: 'sample-tx-20',
    date: '2026-02-10',
    time: '04:15 pm',
    merchant: 'Cult.Fit Gym Pass',
    rawMerchant: 'Curefit Healthcare',
    normalized: 'cultfitgympass',
    amount: 1999.00,
    type: 'debit',
    category: 'Health',
    upiRef: '640455321020',
    transactionId: 'T2602101615293847561928',
    status: 'Success'
  },
  {
    id: 'sample-tx-21',
    date: '2026-02-05',
    time: '06:00 pm',
    merchant: 'Ola Cabs',
    rawMerchant: 'ANI Technologies',
    normalized: 'olacabs',
    amount: 280.00,
    type: 'debit',
    category: 'Transport',
    upiRef: '640455321021',
    transactionId: 'T2602051800293847561028',
    status: 'Success'
  },
  {
    id: 'sample-tx-22',
    date: '2026-02-01',
    time: '10:00 am',
    merchant: 'Monthly Retainer Salary',
    rawMerchant: 'Credited by Acme Corp',
    normalized: 'monthlyretainersalary',
    amount: 45000.00,
    type: 'credit',
    category: 'Income',
    upiRef: '640455321022',
    transactionId: 'T2602011000192837465928',
    status: 'Success'
  },
  {
    id: 'sample-tx-23',
    date: '2026-01-28',
    time: '03:40 pm',
    merchant: 'Nature Basket',
    rawMerchant: 'Natures Basket Supermarket',
    normalized: 'naturebasket',
    amount: 1120.00,
    type: 'debit',
    category: 'Groceries',
    upiRef: '640455321023',
    transactionId: 'T2601281540293847561928',
    status: 'Success'
  },
  {
    id: 'sample-tx-24',
    date: '2026-01-20',
    time: '08:00 pm',
    merchant: 'Myntra Fashion',
    rawMerchant: 'Myntra Designs',
    normalized: 'myntrafashion',
    amount: 1890.00,
    type: 'debit',
    category: 'Shopping',
    upiRef: '640455321024',
    transactionId: 'T2601202000293847561029',
    status: 'Success'
  },
  {
    id: 'sample-tx-25',
    date: '2026-01-15',
    time: '02:20 pm',
    merchant: 'Starbucks Coffee',
    rawMerchant: 'Tata Starbucks Pvt Ltd',
    normalized: 'starbuckscoffee',
    amount: 375.00,
    type: 'debit',
    category: 'Food & Dining',
    upiRef: '640455321025',
    transactionId: 'T2601151420192837465928',
    status: 'Success'
  },
  {
    id: 'sample-tx-26',
    date: '2026-01-01',
    time: '10:00 am',
    merchant: 'Monthly Retainer Salary',
    rawMerchant: 'Credited by Acme Corp',
    normalized: 'monthlyretainersalary',
    amount: 45000.00,
    type: 'credit',
    category: 'Income',
    upiRef: '640455321026',
    transactionId: 'T2601011000192837465928',
    status: 'Success'
  }
];
